module.exports = __webpack_public_path__ + "img/customer2_12.817dfab6.png";